import React from 'react';
import BlockHeader from 'swag-client-common/components/ui/block-header';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import cupImage from 'assets/svg/cup.svg';
import iconDesignImage from 'assets/svg/icon-design.svg';
import peopleImage from 'assets/svg/people.svg';
import classes from './promises.scss';
const Promises = () => /*#__PURE__*/React.createElement("div", {
  className: classes.ourMissionContainer
}, /*#__PURE__*/React.createElement("div", {
  className: classes.ourMission
}, /*#__PURE__*/React.createElement(BlockHeader, {
  textClassName: classes.sectionHeader
}, "Our Promise"), /*#__PURE__*/React.createElement(AnimationWrapper, {
  className: classes.row
}, /*#__PURE__*/React.createElement("div", {
  className: classes.block
}, /*#__PURE__*/React.createElement("img", {
  src: cupImage,
  alt: "Gold trophy cup icon with a star"
}), /*#__PURE__*/React.createElement("h5", {
  className: classes.blockHeader
}, "Only Quality"), /*#__PURE__*/React.createElement("p", {
  className: classes.blockText
}, "We\u2019ve curated the best of what\u2019s out there. We\u2019ve tested thousands of products and 95% didn\u2019t make the cut. We want to make sure every product you order, you\u2019re proud to show off.")), /*#__PURE__*/React.createElement("div", {
  className: classes.block
}, /*#__PURE__*/React.createElement("img", {
  src: iconDesignImage,
  alt: "Icon depicting graphic design tools with a pencil and paintbrush in front of a computer monitor"
}), /*#__PURE__*/React.createElement("h5", {
  className: classes.blockHeader
}, "Streamlined Experience"), /*#__PURE__*/React.createElement("p", {
  className: classes.blockText
}, "We\u2019ve automated the entire buying experience. Easily find what you\u2019re looking for, upload your design, mockup your products and checkout in a matter of seconds. It\u2019s that simple.")), /*#__PURE__*/React.createElement("div", {
  className: classes.block
}, /*#__PURE__*/React.createElement("img", {
  src: peopleImage,
  alt: "Stylized icon of three figures representing a group of people"
}), /*#__PURE__*/React.createElement("h5", {
  className: classes.blockHeader
}, "Customer Obsessed"), /*#__PURE__*/React.createElement("p", {
  className: classes.blockText
}, "Our team is always here to help. If you don\u2019t see what you\u2019re looking for, let us know, and we will be able to source it for you. We will do whatever we can to make your experience stress free and fun.")))));
export default Promises;